<template>
  <div>
    <v-row>
      <v-col cols="6" class="pb-0" v-if="model.TipoOperacaoCred === 3">
        <v-row>
          <input-number label="Valor do Bem" v-model="model.VlrProdutoBem" @input="changeVlrTAC" format="currency"
            :rules="vlrSolicitadoRules" required />
          <v-tooltip top v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
            <template v-slot:activator="{ on }">
              <v-btn class="mr-lg-2" color="primary" v-on="on" small icon><v-icon medium>ph-info</v-icon></v-btn>
            </template>
            <span>Informe o valor total do imóvel (considerando também saldo devedor, se houver).</span>
          </v-tooltip>
        </v-row>
      </v-col>
      <v-col cols="6" class="pb-0" v-else-if="model.TipoCalculoFluxo !== $aux.TipoFluxoEnum.Irregular">
        <input-number label="Valor Solicitado" v-model="model.VlrSolicitado" @input="changeVlrTAC" format="currency"
          :rules="vlrSolicitadoRules" required />
      </v-col>
      <v-col cols="6" class="pb-0" v-else>
        <input-number :label="tipoValor === 1 ? 'Valor Solicitado' : 'Valor Total do Crédito'" v-model="model.VlrSolicitado" @input="changeVlrTAC" format="currency"
          :rules="vlrSolicitadoRules" required />
      </v-col>
      <v-col cols="6" v-if="model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular">
        <input-radiogroup row v-model="tipoValor" required name="Tipo de valor">
          <v-radio :value="1"><template slot="label"> <span class="mr-2">Valor Solicitado</span> </template> </v-radio>
          <v-radio :value="2"><template slot="label"> <span class="mr-2">Valor Total do Crédito</span> </template> </v-radio>
        </input-radiogroup>
      </v-col>
      <v-col cols="6" v-if="model.TipoOperacaoCred === 3">
        <input-number label="Entrada" v-model="model.VlrEntrada" @input="changeVlrTAC" format="currency" required
          :rules="vlrEntradaRule" />
      </v-col>
      <v-col cols="6" v-if="model.TipoCalculoFluxo !== $aux.TipoFluxoEnum.Irregular">
        <input-number label="Tarifa de Cadastro" :min="vlrMinTAC" v-model="model.VlrTAC" format="currency" required />
      </v-col>
      <v-col cols="6" v-if="model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular">
        <input-text  class="mt-16" label="Tarifa de Cadastro - BMP" disabled :value="$api.UI.Format.Currency(vlrMinTAC)"></input-text>
      </v-col>
      <v-col cols="6" v-if="model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular">
        <v-row class="mt-0 pt-0 ml-2">
            <input-radiogroup name="Tac Corban" row v-model="model.TipoTacCorban" @change="changeTipoTacCorban" value="R$">
              <v-radio label="%" value="%"/>
              <v-radio label="R$" value="R$"/>
            </input-radiogroup>
        </v-row>
        <v-col cols="12" class="mt-0 pt-0">
          <v-row class="mt-0 pt-0">
            <input-number v-if="model.TipoTacCorban === 'R$'" label="Tarifa de Cadastro - Corban" v-model="model.VlrTcCorban" format="currency" required />
            <input-number v-else label="Tarifa de Cadastro - Corban" v-model="model.PercTcCorban" format="percent" :precision="4" required/>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="6" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
        <input-number label="Valor de Registro do Imóvel" v-model="model.VlrRegistroImovel" format="currency" required />
      </v-col>
      <v-col cols="6" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
        <input-number label="Valor de ITBI" v-model="model.VlrITBI" format="currency" required />
      </v-col>
      <v-col cols="6" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
        <input-number label="Registro de Termo de Garantia" v-model="model.VlrRegistroGarantia" format="currency" required />
      </v-col>
      <v-col cols="12" class="pt-0" v-if="verificaTipoContrato">
        <strong><v-checkbox v-model="model.OutrosServicos" @change="clearOutrosServicos"
            label="Outros Serviços" /></strong>
      </v-col>
      <v-row v-if="verificaTipoContrato">
        <v-col cols="6">
          <input-number label="Seguro" v-model="model.VlrSeguro" format="currency" :disabled="!model.OutrosServicos" />
        </v-col>
        <v-col cols="6">
          <input-number label="Tarifa de Avaliação" v-model="model.VlrAvaliacao" format="currency"
            :disabled="!model.OutrosServicos" />
        </v-col>
        <v-col cols="6">
          <input-number label="Tarifa de Vistoria" v-model="model.VlrVistoria" format="currency"
            :disabled="!model.OutrosServicos" />
        </v-col>
        <v-col cols="6" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
          <input-number label="Taxa de Administração Mensal" v-model="model.VlrTxAdmMensal" format="currency"
          :disabled="!model.OutrosServicos"/>
        </v-col>
        <v-col cols="6" class="mt-0 pt-0" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
          <v-row class="mt-0 pt-0">
            <input-radiogroup name="Seguro MIP" row v-model="model.TipoCampoSeguroMIP" :disabled="!model.OutrosServicos" @change="changeTipoCampoMIP">
              <v-radio label="%" value="%"/>
              <v-radio label="R$" value="R$"/>
            </input-radiogroup>
          </v-row>
          <v-row class="mt-0 pt-0">
            <input-number v-if="model.TipoCampoSeguroMIP === 'R$'" label="Seguro MIP" v-model="model.VlrSeguroMensal1" format="currency" :disabled="!model.OutrosServicos"/>
            <input-number v-else label="Seguro MIP" v-model="model.PercSeguroMensal1" :disabled="!model.OutrosServicos" format="percent" :precision="4"/>
          </v-row>
        </v-col>
        <v-col cols="6" class="mt-0 pt-0" v-if="model.TipoOperacaoCred === 3 && model.TipoContratoSigla === 'FI'">
          <v-row class="mt-0 pt-0" align="center">
            <input-radiogroup name="Seguro DFI" row v-model="model.TipoCampoSeguroDFI" :disabled="!model.OutrosServicos || model.DivisaoNegocio === 'Desenvolvimento Urbano'" @change="changeTipoCampoDFI">
              <v-radio label="%" value="%"/>
              <v-radio label="R$" value="R$"/>
            </input-radiogroup>
          </v-row>
          <v-row class="mt-0 pt-0">
            <input-number v-if="model.TipoCampoSeguroDFI === 'R$'" label="Seguro DFI" v-model="model.VlrSeguroMensal2" format="currency" :disabled="!model.OutrosServicos || model.DivisaoNegocio === 'Desenvolvimento Urbano'"/>
            <input-number v-else label="Seguro DFI" v-model="model.PercSeguroMensal2" format="percent" :disabled="!model.OutrosServicos || model.DivisaoNegocio === 'Desenvolvimento Urbano'" :precision="4"/>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="6" v-if="model.TipoCalculoFluxo !== $aux.TipoFluxoEnum.Irregular">
        <input-text label="Valor Total Solicitado" :value="$api.UI.Format.Currency(valorTotalSolicitado)" readonly
          required />
      </v-col>
      <v-col cols="6">
        <input-select
          label="Prestações"
          v-model="model.Prazo"
          :options="model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular ? parcelas.slice(1) : parcelas"
          required />
      </v-col>
      <v-col cols="6">
          <InputDateText label="Data da Emissão" v-model="model.DtEmissao" :min="dtMin" :max="isFluxoIrregular ? dtMin : dtMax" required :disabled="isFluxoIrregular"/>
        </v-col>
      <template v-if="model.TipoCalculoFluxo === $aux.TipoFluxoEnum.Irregular">
        <v-col cols="12">
          <TabelaParcelaFluxoIrregular v-model="model" :tipoValor="tipoValor" />
        </v-col>
      </template>
        <v-col cols="6" v-else>
          <input-date-select-data-base
            label="Data do 1º Vencimento"
            v-model="model.DtPrimeiroVencto"
            :items="datasVencimentos"
            :return-object="false"
            :max="dtMax"
            :min="model.DtEmissao"
            :show-current="model.DtPrimeiroVencto"
            required
            :disabled="!model.DtEmissao">
            <template v-slot:selection="{ value }">
              {{ diaAno(value) }}
            </template>
          </input-date-select-data-base>
        </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props: {
    value: null
  },
  data () {
    return {
      OutrosServicos: false,
      dtMin: this.$api.UI.Format.Date(new Date(), 'yyyy-MM-dd'),
      dtMax: this.$api.UI.Format.Date(
        this.$api.UI.Date.AddYear(new Date(), 10),
        'yyyy-MM-dd'
      ),
      parcelas: [],
      VlrPropostaMinimo: 0,
      VlrPropostaMaximo: 0,
      datasVencimentos: this.$param.EST_VENCIMENTOS,
      tipoValor: 1,
      IOF_NOTA: 0.001
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    vlrRegistro () {
      return this.model.GarantiaSimulacao?.reduce((acc, obj) => acc + obj.VlrRegistro, 0);
    },
    vlrMinTAC () {
      return this.$api.Estruturadas.GetVlrMinTAC(this,
        this.model.TipoOperacaoCred,
        this.model.VlrProdutoBem,
        this.model.VlrEntrada,
        this.model.VlrSolicitado
      )
    },
    valorTotalSolicitado () {
      let valorFin = (this.model.VlrTAC || 0) + (this.model.TipoOperacaoCred === 3 ? this.model.VlrProdutoBem : this.model.VlrSolicitado)
      if (this.model.TipoOperacaoCred === 3 && this.model.VlrEntrada < this.model.VlrProdutoBem) {
        valorFin -= this.model.VlrEntrada;
      }
      if (this.model.OutrosServicos === true) {
        valorFin +=
          (this.model.VlrSeguro || 0) +
          (this.model.VlrAvaliacao || 0) +
          (this.model.VlrVistoria || 0);
      }
      if (this.model.TipoContratoSigla === 'FI') {
        valorFin += (this.model.VlrITBI || 0) + (this.model.VlrRegistroImovel || 0) + (this.model.VlrRegistroGarantia || 0);
      }
      return valorFin;
    },
    verificaTipoContrato () {
      let produto = []
      produto = this.$api.Estruturadas.TipoContrato.find(p => p.value === this.model.TipoContratoSigla)
      if (produto?.grupo === this.$aux.GrupoGarantiaProdutoEnum.Movel || produto?.grupo === this.$aux.GrupoGarantiaProdutoEnum.Imovel || this.$param.OutrosServicos) {
        return true
      }
      return false
    },
    isentaIOF () {
      return this.$api.Estruturadas.isNotaComercial(this.model.TipoContratoSigla) || this.model.IsentarIOF
    },
    simulaComIndexador () {
      return this.$param.SimulaComIndexador
    },
    isFluxoIrregular () {
      return this.model.TipoCalculoFluxo === this.$aux.TipoFluxoEnum.Irregular
    }
  },
  methods: {
    vlrSolicitadoRules () {
      if (this.model.VlrSolicitado) {
        return [
          this.model.VlrSolicitado >= this.VlrPropostaMinimo || 'O valor mínimo permitido é de ' + this.$api.UI.Format.Currency(this.VlrPropostaMinimo),
          this.model.VlrSolicitado <= this.VlrPropostaMaximo || 'O valor máximo permitido é de ' + this.$api.UI.Format.Currency(this.VlrPropostaMaximo)
        ]
      } else if (this.model.VlrProdutoBem && this.model.VlrEntrada) {
        return [
          this.model.VlrProdutoBem - this.model.VlrEntrada >= this.VlrPropostaMinimo || 'O (Valor do Bem - Entrada) deve ser maior que ' + this.$api.UI.Format.Currency(this.VlrPropostaMinimo),
          this.model.VlrProdutoBem - this.model.VlrEntrada <= this.VlrPropostaMaximo || 'O (Valor do Bem - Entrada) deve ser menor que ' + this.$api.UI.Format.Currency(this.VlrPropostaMaximo)
        ]
      }
    },
    changeVlrTAC () {
      this.$nextTick(function () {
        if (!this.model.VlrTAC || this.model.VlrTAC < this.vlrMinTAC) {
          this.$set(this.model, 'VlrTAC', this.vlrMinTAC)
        }
        if (this.isFluxoIrregular) {
          this.$set(this.model, 'VlrTcBmp', this.vlrMinTAC)
        }
      })
    },
    submit (callback) {
      const th = this
      th.model.VlrSolicitado = th.model.TipoOperacaoCred === 3 ? (th.model.VlrProdutoBem - th.model.VlrEntrada) : th.model.VlrSolicitado
      th.model.VlrSolicitado += th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? (th.model.VlrITBI + th.model.VlrRegistroImovel + th.model.VlrRegistroGarantia) : 0

      const method = th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? 'CalculaGridParcelasSimplificadoSAC' : 'CalculaGridParcelasSimplificadoPrice'

      const obj = {
        dto: {
          Prazo: th.model.Prazo,
          VlrSeguro: (th.model.VlrSeguro || 0),
          VlrAvaliacao: (th.model.VlrAvaliacao || 0),
          VlrVistoria: (th.model.VlrVistoria || 0),
          TipoPessoa: th.$api.UI.Format.SomenteAlfanumerico(th.model.DocumentoFederal).length === 11 ? 1 : 2,
          NroDiasAcrescimo: th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), th.model.DtPrimeiroVencto),
          VlrSolicitado: th.model.VlrSolicitado,
          VlrEntrada: th.model.TipoOperacaoCred === 3 ? th.model.VlrEntrada : 0,
          VlrProdutoBem: th.model.VlrProdutoBem,
          VlrTAC: th.model.VlrTAC,
          PercJurosNegociado: th.model.TipoContratoSigla === 'FI' ? th.$api.Estruturadas.JurosAnualParaMensal(th.model.TxJuros) : th.model.TxJuros,
          VlrOutrosServicos: th.vlrRegistro
        },
        parametros: []
      }
      if (th.model.TipoOperacaoCred === 3) {
        obj.dto.VlrProdutoBem = th.model.VlrProdutoBem
      }

      if (th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        if (th.model.TipoIndexador === 2) {
          obj.dto.TipoIndiceFinanceiro = th.model.TipoIndiceFinan
          obj.dto.PercIndiceFinanceiro = th.model.PercIndiceFinan
        }
        obj.dto.VlrTxAdmMensal = th.model.VlrTxAdmMensal
        obj.dto.PercSeguroMensal1 = th.model.PercSeguroMensal1
        obj.dto.PercSeguroMensal2 = th.model.PercSeguroMensal2
        obj.dto.VlrSeguroMensal1 = th.model.VlrSeguroMensal1
        obj.dto.VlrSeguroMensal2 = th.model.VlrSeguroMensal2
      }

      if (th.isentaIOF) {
        obj.parametros.push({ Nome: 'PROPOSTA_ISENTARIOF', Valor: true })
        obj.dto.VlrIOF = th.IOF_NOTA
      }

      if (th.simulaComIndexador) {
        obj.dto.IncluirCorrecaoPos = true
      }

      if (th.isFluxoIrregular) {
        return callback()
      }

      th.$api.Multiplo.Post(method, obj).then(
        (result) => {
          const proposta = result.Proposta

          th.$set(th, 'model', {
            ...th.model,
            ...proposta,
            VlrIOF: th.isentaIOF ? th.IOF_NOTA : result.Proposta.VlrIOF
          });

          th.$set(th.model, 'Parcelas', proposta.Parcelas)
          th.$set(th.model, 'CodigoSimulacao', proposta.CodigoSimulacao)

          if (th.$api.Estruturadas.isNotaComercial(th.model.TipoContratoSigla) && !Number.isInteger(result.Proposta.VlrTotalCredito)) {
            th.$api.Estruturadas.RoundNotaComercial(th, callback, true)
          } else {
            if (callback) callback()
          }
        }
      )
    },
    clearOutrosServicos () {
      this.$set(this.model, 'VlrSeguro', null)
      this.$set(this.model, 'VlrAvaliacao', null)
      this.$set(this.model, 'VlrVistoria', null)
      this.$set(this.model, 'VlrSeguroMensal1', null)
      this.$set(this.model, 'VlrSeguroMensal2', null)
      this.$set(this.model, 'PercSeguroMensal1', null)
      this.$set(this.model, 'PercSeguroMensal2', null)
      this.$set(this.model, 'VlrTxAdmMensal', null)
      this.$set(this.model, 'TipoCampoSeguroDFI', null)
      this.$set(this.model, 'TipoCampoSeguroMIP', null)
    },
    vlrEntradaRule () {
      if (this.model.TipoOperacaoCred === 3) {
        return [this.model.VlrEntrada <= this.model.VlrProdutoBem || 'Valor de Entrada deve ser menor que o Valor do Bem']
      }
      return [true]
    },
    diaAno (value) {
      var date = this.$api.UI.Date.AddDay(this.model.DtEmissao || new Date(), value)
      var textDate = value + (value === 1 ? ' dia' : ' dias')
      textDate += ' - ' + this.$api.UI.Format.Date(date)
      return textDate
    },
    changeTipoCampoDFI (value) {
      if (value === 'R$') {
        this.$set(this.model, 'PercSeguroMensal2', null)
      } else {
        this.$set(this.model, 'VlrSeguroMensal2', null)
      }
    },
    changeTipoCampoMIP (value) {
      if (value === 'R$') {
        this.$set(this.model, 'PercSeguroMensal1', null)
      } else {
        this.$set(this.model, 'VlrSeguroMensal1', null)
      }
    },
    changeTipoTacCorban (value) {
      if (value === 'R$') {
        this.$set(this.model, 'PercTcCorban', null)
      } else {
        this.$set(this.model, 'VlrTcCorban', null)
      }
    }
  },
  beforeMount () {
    const th = this;
    th.$api.Multiplo.Post('ListProdutoRedeParcela', {}).then(function (
      response
    ) {
      var parcelas = response.map((p) => {
        return { text: p.toString(), value: p };
      });
      th.$set(th, 'parcelas', parcelas);
    });
  },
  mounted () {
    const th = this
    th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (response) {
      if (th.$api.UI.PostLoadData(response, true)) {
        th.$set(th, 'VlrPropostaMinimo', response.VlrPropostaMinimo)
        th.$set(th, 'VlrPropostaMaximo', response.VlrPropostaMaximo)
      }
    })
  },
  watch: {
    'model.Prazo' () {
      if (this.isFluxoIrregular) {
        this.model.DtEmissao = this.dtMin
      }
    }
  }
}
</script>
